import React from 'react';
var Indicator = function (props) {
    var size = props.size, className = props.className;
    return (React.createElement("div", { className: className + " " + className + "_" + size },
        React.createElement("span", { className: className + "-dot" }),
        React.createElement("span", { className: className + "-dot" }),
        React.createElement("span", { className: className + "-dot" }),
        React.createElement("span", { className: className + "-dot" })));
};
export default Indicator;
//# sourceMappingURL=indicator.js.map